'use client';

import React from 'react';

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';
import { useDrawer } from 'src/hooks/drawers/useDrawer';
import useTableFilterSelections from 'src/hooks/filters/useTableFilterSelections';

interface TableVolumeButtonProps {
  hasVisibleVolumeColumns: boolean;
  location: string;
}
const TableVolumeButton = ({
  hasVisibleVolumeColumns,
  location,
}: TableVolumeButtonProps) => {
  const { closeAllButCurrent } = useDrawer();
  const { setColumnId, isTrending } = useTableFilterSelections(location);

  return (
    <div className="flex items-center justify-center w-full h-full">
      {hasVisibleVolumeColumns ? (
        <button
          className={`w-8 h-8 min-w-0 p-0 rounded-full inline-flex items-center justify-center 
                ${
                  isTrending
                    ? 'bg-teal-100 cursor-not-allowed'
                    : 'bg-teal-600 hover:bg-teal-500'
                }
            `}
          onClick={(e) => {
            e.stopPropagation();
            setColumnId(null); // No isEditing flag - this is for NEW columns
            closeAllButCurrent(`table-volume-${location}`);
          }}
          disabled={isTrending}
        >
          <Icon icon={faPlus} className="w-4 h-4 text-white" />
        </button>
      ) : (
        <button
          className="self-stretch px-4 py-1.5 rounded-full inline-flex justify-between items-center bg-teal-600 hover:bg-teal-500"
          onClick={(e) => {
            e.stopPropagation();
            setColumnId(null); // No isEditing flag - this is for NEW columns
            closeAllButCurrent(`table-volume-${location}`);
          }}
        >
          <div className="flex justify-start items-center gap-2">
            <div className="w-4 h-5 flex items-center justify-center">
              <Icon icon={faPlus} className="w-3 h-3 text-white" />
            </div>
            <div className="justify-start text-white text-sm font-semibold font-['Inter'] leading-tight">
              Add Code Set
            </div>
          </div>
        </button>
      )}
    </div>
  );
};

export default TableVolumeButton;
